// ucakSaatleri.js — UÇAK GÖVDESİ VE MOTOR SAATLERİ: TEK KAYNAK (2 Eki 2026)
//
// 🔑 Serkan (1-2 Eki 2026, ofis talebi): "baseline dk yok sadece saat var" → taban HHHH:MM, dakika saklanır ·
//    "motor saatleri sağ ve sol görünsün" · motor sayısı TİPTEN ("tiplerde varsa add eng olmasın" — 353 tipin
//    hepsinde var) · motor tabanı TARİHLİ (A) · "uçak saati take off ve landing olmalı" (blok değil) ·
//    "motor her bacakta cycle sayar" · "gövde iniş sayısına göre cycle sayar".
// GÖVDE  saat = base_minutes + uygulamanın kaydettiği her uçuşun kalkış → iniş süresi · döngü = taban + iniş sayısı.
// MOTOR  saat = o yerin güncel tabanı + tabanın AS OF günü DAHİL sonraki uçuşların kalkış → iniş süresi ·
//        döngü = taban + o uçuşların BACAK sayısı (bir bacak = bir döngü; iniş sayısı değil).
// AS OF: taban o günün BAŞINDAKİ değerdir; o günün uçuşları da eklenir. 🔑 Serkan (3 Eki 2026): *"saatleri ve cycle girerken
//    girdiğimiz gün dahil olacaktı, o güne kadar değil — 1 cycle ve 1 saatlik sapma var"*. 2 Eki'de "günün SONU" diye
//    kurulmuştu (onaya sunulmuş, cevap gelmemişti): AS OF günündeki bacak hiç sayılmıyordu.

const iki = (n) => String(n).padStart(2, '0');

/** "4100:30" → 246030 dk · boş/okunamaz → null. Dakika iki hane (eksik giriş olmasın). */
export function saatDkCoz(metin) {
  const m = String(metin ?? '').trim().match(/^(\d{1,6}):([0-5]\d)$/);
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}

/** 246030 → "4100:30" · null → "—" */
export function dkSaat(dk) {
  if (dk == null || Number.isNaN(Number(dk))) return '—';
  const d = Math.max(0, Math.round(Number(dk)));
  return `${Math.floor(d / 60)}:${iki(d % 60)}`;
}

/** Tip listesindeki motor alanı ("2J", "3J", "1T") → 2 · 3 · 1 · okunamazsa null */
export function motorSayisi(engine) {
  const m = String(engine ?? '').match(/^(\d+)/);
  return m ? Number(m[1]) : null;
}

/** Tipin motor sayısı — aynı kodun bütün satırları (2 Eki'de ölçüldü: çelişen yok). Bulunamazsa null. */
export function tipMotorSayisi(tipler, acType) {
  const kod = String(acType ?? '').toUpperCase();
  const s = (tipler || []).map(t => (t.designator === kod ? motorSayisi(t.engine) : null)).find(x => x != null);
  return s ?? null;
}

/** "ENG 1 (LH)" — iki motorda LH/RH, üç motorda LH/CTR/RH; öteki sayılarda yalnız numara. */
export function motorAdi(sira, adet) {
  const yan = adet === 2 ? ['LH', 'RH'][sira - 1] : adet === 3 ? ['LH', 'CTR', 'RH'][sira - 1] : null;
  return `ENG ${sira}${yan ? ` (${yan})` : ''}`;
}

/** Bir uçağın her motor yeri için GÜNCEL tabanı (en yeni AS OF, eşitse en yeni kayıt). { [position]: satır } */
export function guncelMotorTabanlari(satirlar, aircraftId) {
  const out = {};
  (satirlar || []).filter(s => s.aircraft_id === aircraftId).forEach(s => {
    const o = out[s.position];
    if (!o || s.as_of > o.as_of || (s.as_of === o.as_of && String(s.created_at) > String(o.created_at))) out[s.position] = s;
  });
  return out;
}

/** Formdaki motor alanlarından YAZILACAK taban satırları. Üç alan (saat HHHH:MM · döngü · AS OF) ya hep dolu ya
 *  hep boş: boş yer yazılmaz (motor NOT SET kalır), kısmen dolu yer HATA. Güncel tabanla aynı olan yer yazılmaz
 *  (düzenlemede değişmeyen motor için yeni satır doğmaz). motorlar: { [yer]: { saat, dongu, tarih } }.
 *  @returns {{ satirlar?: object[], hata?: string }} */
// SERİ NUMARASI (3 Eki 2026, Serkan B): *"her motor için S/N girmemiz lazım, motor sökülüp yeni motor takılırsa seri
// numarası ile ayrıştırabiliriz"* · *"kiralık motor gelir saatiyle, belli bir süre sonra sökülür"* — S/N motorun KİMLİĞİDİR;
// saat ve döngü her takışta ofisçe girilir (S/N'den otomatik devir YOK). Dört alan birlikte: S/N, saat, döngü, AS OF.
export const motorSeriNo = (v) => String(v ?? '').trim().toUpperCase();
/** Bir motor satırının alan ölçüsü — kapı (`motorFormuSatirlari`) ve zorunlu alan rengi AYNI ölçü (5 Eki 2026).
 *  `basladi`: dört alandan biri yazılmış — o zaman dördü de zorunlu (ya hep ya hiç). */
export function motorAlanDurumu(v = {}) {
  const sn = motorSeriNo(v?.sn);
  return {
    basladi: [v?.sn, v?.saat, v?.dongu, v?.tarih].some(x => String(x ?? '').trim() !== ''),
    sn: !!sn && sn.length <= 40,
    saat: saatDkCoz(v?.saat) != null,
    dongu: /^\d+$/.test(String(v?.dongu ?? '').trim()),
    tarih: /^\d{4}-\d{2}-\d{2}$/.test(String(v?.tarih || '')),
  };
}
export function motorFormuSatirlari(motorlar, adet, mevcut = {}) {
  const satirlar = [];
  for (let i = 1; i <= (adet || 0); i++) {
    const v = (motorlar || {})[i] || {};
    const d = motorAlanDurumu(v);
    if (!d.basladi) continue;
    const sn = motorSeriNo(v.sn);
    const dk = saatDkCoz(v.saat);
    const dg = d.dongu ? parseInt(v.dongu, 10) : null;
    const t = d.tarih ? v.tarih : null;
    if (!d.sn || !d.saat || !d.dongu || !d.tarih) {
      return { hata: `${motorAdi(i, adet)}: enter SERIAL NO., HOURS as HHHH:MM with minutes 00–59 (type 386430 for 3864:30), CYCLES and AS OF — all four, or leave all four empty.` };
    }
    const e = mevcut[i];
    if (e && (e.serial_number || '') === sn && e.base_minutes === dk && e.base_cycles === dg && e.as_of === t) continue;
    satirlar.push({ position: i, serial_number: sn, base_minutes: dk, base_cycles: dg, as_of: t });
  }
  return { satirlar };
}

/** Arşiv ve kâğıt uçuş satırlarını tek biçime getirir: { reg, tarih, dk, inis }. Tarih = kalkışın UTC günü.
 *  Serkan (2 Eki): "kalkış iniş girilmeyen uçuş olmaz" — `tarih` yedeği yalnız eski/bozuk kayıt içindir. */
export function ucusSatiri({ reg, takeoff_time, tarih, airborne_minutes, landing_count }) {
  const gun = takeoff_time ? new Date(takeoff_time).toISOString().slice(0, 10) : (tarih || null);
  return { reg: reg || null, tarih: gun, dk: airborne_minutes || 0, inis: landing_count || 0 };
}

/** Gövde: taban + uçuşlar (saat kalkış → iniş, döngü iniş sayısı).
 *  BASELINE AS OF (3 Eki 2026, Serkan "başla"): `base_as_of` varsa taban o günün BAŞINDAKİ değerdir ve o gün DAHİL
 *  sonraki uçuşlar eklenir (motorla aynı kural). Yoksa bütün uçuşlar eklenir — ekran "BASELINE DATE NOT SET" der.
 *  🔴 Vaka (TC-REC, 3 Eki): taban tarihsizdi; logbook 2362 döngü / uygulama 2363 — tabanın içindeki bir uçuş ikinci kez
 *     sayılıyordu ve hangi gün alındığı hiçbir yerde yazmıyordu. */
export function govdeToplami(ucak, ucuslar) {
  const tarih = ucak.base_as_of || null;
  const benim = (ucuslar || []).filter(u => u.reg && u.reg === ucak.registration && (!tarih || (u.tarih && u.tarih >= tarih)));
  const ekDk = benim.reduce((a, u) => a + u.dk, 0), ekDongu = benim.reduce((a, u) => a + u.inis, 0);
  return { dk: (ucak.base_minutes || 0) + ekDk, dongu: (ucak.total_cycles || 0) + ekDongu, ekDk, ekDongu };
}

/** Motor: güncel taban + AS OF günü DAHİL sonraki uçuşlar (saat kalkış → iniş, döngü = bacak sayısı). */
export function motorToplami(taban, reg, ucuslar) {
  if (!taban) return null;
  const sonra = (ucuslar || []).filter(u => u.reg && u.reg === reg && u.tarih && u.tarih >= taban.as_of);
  const ekDk = sonra.reduce((a, u) => a + u.dk, 0);
  return { dk: taban.base_minutes + ekDk, dongu: taban.base_cycles + sonra.length, ekDk, ekDongu: sonra.length };
}

// ── UÇUŞ RAPORUNUN SAATLERİ — "AFTER THIS FLIGHT" (12 Eki 2026) ─────────────────────────────────────────────────────────
// 🔑 Serkan: *"elimizde gerçek uçak saati var zaten; internet erişimi gelince son yapılan saati de bir önceki toplam saatlere
//    eklesin, güncel veriyi versin; rapor aynı zamanda aircraft modülü de güncellenecek — tek kaynak prensibi"*.
// 🔴 Önce rapor veritabanındaki eski `aircraft_hours` fonksiyonunu çağırıyordu: taban (3 Eki, 3981:18 / 2362), taban tarihi ve
//    motor tabanları yoktu — TC-REC raporunda gövde de iki motor da "50:03 h", döngü 22 (AIRCRAFTS: 3995:38 / 2367, 3878:50).
// Artık AIRCRAFTS ekranının AYNI hesabı (`govdeToplami` · `motorToplami`), AYNI uçuşlarla (uygulama + kâğıt OFP, silinenler
// hariç) — yalnız BU UÇUŞA KADAR olanlar (kalkışı bu uçuşunkinden geç olmayanlar). En son uçuşta AIRCRAFTS'taki toplamın
// aynısıdır; eski bir uçuş yeniden üretilirse o uçuşun bittiği andaki değer basılır (bugünkü toplam değil).
// Uçuş tabanın AS OF gününden ÖNCEYSE o anki değer kayıttan bilinemez → `once` (rapor "before baseline" yazar, sayı uydurmaz).
/** @param ucak            aircraft satırı (registration, base_minutes, total_cycles, base_as_of)
 *  @param motorSatirlari  aircraft_engine_baselines satırları (bu uçağın)
 *  @param motorAdedi      tipten motor sayısı (`tipMotorSayisi`) — bilinmiyorsa null (motor satırı çıkmaz)
 *  @param ucuslar         ham satırlar { reg, takeoff_time (ISO), tarih, airborne_minutes, landing_count }
 *  @param kalkisISO       bu uçuşun kalkışı (ISO)
 *  @returns {{ govde: {dk,dongu}|{once,tarih}, motorlar: {sira,ad,sn,dk,dongu}|{sira,ad,notSet}|{sira,ad,sn,once,tarih}[] }} */
export function ucusSonrasiSaatler({ ucak, motorSatirlari = [], motorAdedi = null, ucuslar = [], kalkisISO }) {
  const kalkisMs = Date.parse(kalkisISO || '');
  const gun = Number.isFinite(kalkisMs) ? new Date(kalkisMs).toISOString().slice(0, 10) : null;
  const buUcusaKadar = (ucuslar || []).filter((u) => {
    if (!u || u.reg !== ucak.registration) return false;
    const t = Date.parse(u.takeoff_time || '');
    if (Number.isFinite(t) && Number.isFinite(kalkisMs)) return t <= kalkisMs;
    return !!(gun && u.tarih && u.tarih <= gun);
  }).map(ucusSatiri);
  const govde = ucak.base_as_of && gun && gun < ucak.base_as_of
    ? { once: true, tarih: ucak.base_as_of }
    : (({ dk, dongu }) => ({ dk, dongu }))(govdeToplami(ucak, buUcusaKadar));
  const g = guncelMotorTabanlari(motorSatirlari, ucak.id);
  const motorlar = motorAdedi ? Array.from({ length: motorAdedi }, (_, j) => {
    const sira = j + 1, ad = motorAdi(sira, motorAdedi), taban = g[sira];
    if (!taban) return { sira, ad, notSet: true };
    const sn = taban.serial_number || null;
    if (gun && gun < taban.as_of) return { sira, ad, sn, once: true, tarih: taban.as_of };
    const t = motorToplami(taban, ucak.registration, buUcusaKadar);
    return { sira, ad, sn, dk: t.dk, dongu: t.dongu };
  }) : [];
  return { govde, motorlar };
}
